import { initTelemetryExporters } from "@teladoc/ucs-telemetry-export"
import { logger } from "./logger"

const SERVICE_NAME = "guest-web-app"

export const initTelemetry = (): void => {
  try {
    initTelemetryExporters({
      serviceName: SERVICE_NAME,
      serviceVersion: window.version ?? "unknown",
      environment: window.environment ?? "dev",
      exporterKind: window.config?.OTEL_EXPORTER,
      endpoint: window.config?.OTEL_ENDPOINT,
      logger,
    })
  } catch (error) {
    logger.warn("Skipping OpenTelemetry exporter initialization", {
      error: String(error),
    })
  }
}
